export const shopRoutes = [
  {
    name: 'organizationShop',
    path: '/organization/shop',
    component: () => import('@/modules/shop/views/OrganizationShop.vue'),
    meta: {
      locationTypes: ['organization', 'singleLocation']
    }
  },
  {
    name: 'locationShop',
    path: '/location/shop',
    component: () => import('@/modules/shop/views/LocationShop.vue'),
    meta: {
      locationTypes: ['location', 'singleLocation']
    }
  }
]
